import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck} from '@fortawesome/free-solid-svg-icons';

const Main = ({children, stepName}) => {
  return (
    <div className="columns is-centered">
      <div className="column is-6-desktop">
        <div>
          <h1 className="is-size-4 is-size-4-mobile has-text-weight-bold">
            Graffer 電子証明書取得サポート <span className="is-size-5">へようこそ！</span>
          </h1>
          <p>スムーズなサービスのご利用のために、事前設定をお願いします。</p>
        </div>
        <div style={{padding: '40px 0'}}>
          <div className="steps">
            <div className={`step-item  is-info ${stepName === '自社設定' ? 'is-active' : 'is-completed'}`}>
              <div className="step-marker">
                <span className="icon">
                  <FontAwesomeIcon icon={faCheck}/>
                </span>
              </div>
              <div className="step-details">
                <p className="step-title is-size-6 is-size-7-mobile">自社設定</p>
              </div>
            </div>
            <div className={`step-item  is-info ${stepName === '印鑑提出者設定' && 'is-active'}`}>
              <div className="step-marker">
                <span className="icon">
                  <FontAwesomeIcon icon={faCheck}/>
                </span>
              </div>
              <div className="step-details">
                <p className="step-title is-size-6 is-size-7-mobile">印鑑提出者設定</p>
              </div>
            </div>
          </div>
        </div>
        <div className="columns is-centered">
          <div className="column is-12">
            <div className="box">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Main;